import { useTranslation } from 'react-i18next';

import { Forbidden } from '@/modules/auth/Forbidden';
import { useAuthorization } from '@/modules/auth/useAuthorization';
import { useVenueContext } from '@/modules/venue/VenueContext';
import { MvpCardNumberGenerator } from './MvpCardNumberGenerator';

/** Printer batches are available to mvp.sell staff without granting customer-history access. */
export function MvpCardNumbersPage() {
  const { t } = useTranslation('common');
  const auth = useAuthorization();
  const { venueId } = useVenueContext();

  if (!auth.can('mvp.sell', { kind: 'venue', venueId })) return <Forbidden />;

  return (
    <section className="grid gap-4 p-6">
      <header className="grid gap-1">
        <h1 className="text-2xl font-semibold">{t('mvpCardNumbers.title')}</h1>
        <p className="text-muted-foreground">{t('mvpCardNumbers.description')}</p>
      </header>
      <MvpCardNumberGenerator />
    </section>
  );
}
